import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

type TypeChangePhoneNumberParams = {
  phoneNumber: string;
  verificationCode: string;
};

type TypeChangePhoneNumberResponse = {
  code: string;
  message: string;
};

/** @description 휴대폰 번호 변경 api에 사용되는 커스텀 훅 */
export const useChangePhoneNumber = () => {
  const { mutateAsync } = useMutation({
    mutationFn: (params: TypeChangePhoneNumberParams) => {
      const endpoint = '/labor-accounts/modify-phone-number';
      return axiosInstance.post(endpoint, params);
    },
  });

  const requestChangePhoneNumber = async ({
    params,
    onSuccess,
    onError,
  }: {
    params: TypeChangePhoneNumberParams;
    onSuccess?: (res: TypeChangePhoneNumberResponse) => void;
    onError?: (err: TypeErrorFormat) => void;
  }) => {
    requestHelper(() => mutateAsync(params), onSuccess, onError);
  };

  return requestChangePhoneNumber;
};
